<template>
    <main role="main" :class="`${!siderCollapsed ? 'col-md-12 col-lg-10 ml-sm-auto px-1 main-container' : 'col-md-12 col-lg-11 ml-sm-auto px-1 main-container'}`">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-4 pb-2 mb-3">
            <transition name="page" mode="out-in">
                <router-view />
            </transition>
        </div>
    </main>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: 'main-container',
    computed: {
        ...mapState(['siderCollapsed'])
    }
}
</script>
<style lang="scss" scoped>
    [role="main"] {
        padding-top: 48px;
        transition: 0.3s;
    }
    .page-enter-active, .page-leave-active {
        transition: opacity 0.1s, transform 0.2s;
    }
    .page-enter, .page-leave-to {
        opacity: 0;
        transform: translateX(-30%);
    }
</style>
